/* ============================================================================
   Header Naturalie. Portado de Farmacia Rex:
     - Panel de escritorio: assets/rex-nav.js (hover con gracia, clic que fija, Esc, riel).
     - Cajón mobile: el MobileNavigation de Warehouse (theme.js: toggle-menu / open-panel /
       close-panel) + assets/rex-menu-movil.js (paneles profundos desde JSON, al abrir).
     - Popover de Mi cuenta: el toggle-popover de Warehouse.
     - Placeholder del buscador según el ancho: el <script> inline de sections/header.liquid.
   Sin jQuery ni dependencias. Lo agregado sobre Rex es teclado: foco dentro del panel al
   abrirlo con teclado, flechas en el riel, cierre al salir con Tab y `inert` en el nivel
   que queda tapado en el cajón.
   ============================================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-nat-hdr]');
  if (!root) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])';

  /* ─────────────────────────  PANEL DE ESCRITORIO  ───────────────────────── */
  var nav = root.querySelector('[data-nat-nav]');
  if (nav) {
    var paneles = nav.querySelectorAll('[data-nat-panel]');
    var disparadores = nav.querySelectorAll('[data-nat-abre]');
    var reloj = null;

    var disparadorDe = function (panel) { return nav.querySelector('[aria-controls="' + panel.id + '"]'); };

    var cerrarTodo = function (excepto) {
      paneles.forEach(function (p) {
        if (p === excepto) return;
        p.hidden = true;
        var d = disparadorDe(p);
        if (d) { d.setAttribute('aria-expanded', 'false'); delete d.dataset.natFijo; }
      });
    };

    var abrir = function (disparador) {
      var panel = document.getElementById(disparador.getAttribute('aria-controls'));
      if (!panel) return null;
      clearTimeout(reloj);
      cerrarTodo(panel);
      panel.hidden = false;
      disparador.setAttribute('aria-expanded', 'true');
      return panel;
    };

    // Los 160 ms son para cruzar el hueco entre el disparador y el panel sin que se cierre.
    var cerrarConGracia = function () {
      reloj = setTimeout(function () {
        // Un panel fijado con clic no se cierra por sacar el mouse.
        var fijo = nav.querySelector('[data-nat-abre][data-nat-fijo]');
        cerrarTodo(fijo ? document.getElementById(fijo.getAttribute('aria-controls')) : null);
      }, 160);
    };

    var hover = window.matchMedia('(hover: hover)');

    disparadores.forEach(function (d) {
      var panel = document.getElementById(d.getAttribute('aria-controls'));
      if (!panel) return;

      d.addEventListener('mouseenter', function () {
        if (!hover.matches) return;
        if (nav.querySelector('[data-nat-abre][data-nat-fijo]') && !d.dataset.natFijo) return;
        abrir(d);
      });
      d.addEventListener('mouseleave', function () { if (hover.matches) cerrarConGracia(); });
      panel.addEventListener('mouseenter', function () { clearTimeout(reloj); });
      panel.addEventListener('mouseleave', function () { if (hover.matches) cerrarConGracia(); });

      // El clic FIJA el panel en vez de cerrarlo (hover + clic seguidos lo abrirían y cerrarían
      // en el mismo gesto). Un segundo clic sobre el panel fijado lo cierra.
      d.addEventListener('click', function (e) {
        e.preventDefault();
        if (!panel.hidden && d.dataset.natFijo) {
          cerrarTodo(null);
          return;
        }
        abrir(d);
        d.dataset.natFijo = '1';
        // Abierto con teclado (Enter/Espacio dan detail 0): el foco entra al panel.
        if (e.detail === 0) {
          var primero = panel.querySelector('[data-nat-riel] .is-active') || panel.querySelector(FOCUSABLE);
          if (primero) primero.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nat-panel]') || e.target.closest('[data-nat-abre]')) return;
      cerrarTodo(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var abierto = nav.querySelector('[data-nat-panel]:not([hidden])');
      if (!abierto) return;
      var d = disparadorDe(abierto);
      var focoAdentro = nav.contains(document.activeElement);
      cerrarTodo(null);
      if (d && focoAdentro) d.focus();
    });

    // Salir del header con Tab cierra el panel: no queda abierto tapando la página.
    nav.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !nav.contains(e.relatedTarget)) cerrarTodo(null);
    });

    // Riel de categorías: hover, foco o clic cambian el contenido de la derecha.
    nav.querySelectorAll('[data-nat-riel]').forEach(function (riel) {
      var botones = Array.prototype.slice.call(riel.querySelectorAll('[data-nat-va]'));
      var caja = riel.parentNode.querySelector('[data-nat-destino]');
      var activar = function (b) {
        botones.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        if (caja) caja.querySelectorAll('[data-nat-id]').forEach(function (dep) {
          dep.classList.toggle('is-active', dep.dataset.natId === b.dataset.natVa);
        });
      };
      botones.forEach(function (b, i) {
        b.addEventListener('mouseenter', function () { activar(b); });
        b.addEventListener('focus', function () { activar(b); });
        b.addEventListener('click', function (e) {
          e.preventDefault();
          activar(b);
          // Con teclado, Enter entra a las subcategorías de la categoría activa.
          if (e.detail === 0 && caja) {
            var dep = caja.querySelector('.is-active');
            var link = dep && dep.querySelector(FOCUSABLE);
            if (link) link.focus();
          }
        });
        b.addEventListener('keydown', function (e) {
          var j = e.key === 'ArrowDown' ? i + 1 : e.key === 'ArrowUp' ? i - 1 : null;
          if (j === null) return;
          e.preventDefault();
          botones[(j + botones.length) % botones.length].focus();
        });
      });
    });
  }

  /* ─────────────────────────  POPOVER DE MI CUENTA  ───────────────────────── */
  root.querySelectorAll('[data-nat-pop]').forEach(function (pop) {
    var btn = pop.querySelector('[data-nat-pop-btn]');
    var panel = pop.querySelector('[data-nat-pop-panel]');
    if (!btn || !panel) return;
    var poner = function (abierto) {
      panel.hidden = !abierto;
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    };
    btn.addEventListener('click', function () { poner(panel.hidden); });
    document.addEventListener('click', function (e) { if (!pop.contains(e.target)) poner(false); });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { poner(false); btn.focus(); }
    });
    pop.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !pop.contains(e.relatedTarget)) poner(false);
    });
  });

  /* ─────────────────────────  BUSCADOR  ─────────────────────────
     El texto largo se corta en mobile: en pantalla chica va el corto. */
  var input = root.querySelector('[data-placeholder-ancho]');
  if (input) {
    var mq = window.matchMedia('(min-width: 641px)');
    var aplicar = function () {
      input.setAttribute('placeholder', mq.matches ? input.dataset.placeholderAncho : input.dataset.placeholderAngosto);
    };
    aplicar();
    if (mq.addEventListener) mq.addEventListener('change', aplicar); else mq.addListener(aplicar);

    var limpiar = root.querySelector('[data-nat-search-clear]');
    if (limpiar) {
      var mostrar = function () { limpiar.hidden = input.value === ''; };
      mostrar();
      input.addEventListener('input', mostrar);
      limpiar.addEventListener('click', function () { input.value = ''; mostrar(); input.focus(); });
    }
  }

  /* ─────────────────────────  CAJÓN MOBILE  ───────────────────────── */
  var toggle = root.querySelector('[data-nat-mm-toggle]');
  var menu = root.querySelector('[data-nat-mm]');
  var header = root.querySelector('.nat-hdr__main');
  if (!toggle || !menu || !header) return;

  var cont = menu.querySelector('[data-nat-mm-inner]');
  var abierto = false, construido = false;

  function icono(nombre) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'nat-flecha');
    svg.setAttribute('viewBox', '0 0 10 10');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.6');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', nombre === 'volver' ? 'M6.5 2 3.5 5 6.5 8' : 'M3.5 2 6.5 5 3.5 8');
    svg.appendChild(path);
    return svg;
  }

  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    // textContent y no innerHTML: los títulos vienen de los menús del admin.
    if (texto != null) n.textContent = texto;
    return n;
  }

  function panel(id, titulo) {
    var p = el('div', 'nat-mm__panel is-nested');
    p.id = id;
    var cab = el('div', 'nat-mm__section is-sticky');
    var b = el('button', 'nat-mm__back');
    b.type = 'button';
    b.setAttribute('data-nat-mm-cerrar', '');
    b.appendChild(icono('volver'));
    b.appendChild(el('span', 'nat-sr-only', 'Volver desde '));
    b.appendChild(el('span', null, titulo));
    cab.appendChild(b);
    p.appendChild(cab);
    return p;
  }

  function verTodo(url, texto) {
    if (!url || url === '#') return null;
    var a = el('a', 'nat-mm__todo', texto + ' →');
    a.href = url;
    return a;
  }

  function lista(items, hacerItem) {
    var sec = el('div', 'nat-mm__section');
    var ul = el('ul', 'nat-mm__nav');
    ul.setAttribute('role', 'list');
    items.forEach(function (item, i) {
      var li = el('li');
      li.appendChild(hacerItem(item, i));
      ul.appendChild(li);
    });
    sec.appendChild(ul);
    return sec;
  }

  function enlace(item) {
    var a = el('a', 'nat-mm__link');
    a.href = item.u;
    a.appendChild(el('span', null, item.t));
    a.appendChild(icono('flecha'));
    return a;
  }

  function boton(texto, destino) {
    var b = el('button', 'nat-mm__link');
    b.type = 'button';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-controls', destino);
    b.setAttribute('data-nat-mm-abre', '');
    b.appendChild(el('span', null, texto));
    b.appendChild(icono('flecha'));
    return b;
  }

  // Orden en el DOM: todos los de nivel 2 y después los de nivel 3. Comparten z-index y gana
  // el que está más abajo, así el tercero tapa al segundo (mismo contrato que en Rex).
  function construir() {
    if (construido) return;
    construido = true;
    var datosEl = menu.querySelector('[data-nat-mm-datos]');
    var d;
    try { d = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var n2 = document.createDocumentFragment(), n3 = document.createDocumentFragment();

    (d.dep || []).forEach(function (dep) {
      var p = panel('NatMm-dep-' + dep.i, dep.t);
      var vt = verTodo(dep.u, 'Ver todo en ' + dep.t);
      if (vt) p.appendChild(vt);
      p.appendChild(lista(dep.g || [], function (g, j) {
        return g.h ? boton(g.t, 'NatMm-dep-' + dep.i + '-g-' + j) : enlace(g);
      }));
      n2.appendChild(p);

      (dep.g || []).forEach(function (g, j) {
        if (!g.h) return;
        var q = panel('NatMm-dep-' + dep.i + '-g-' + j, g.t);
        var vt2 = verTodo(g.u, 'Ver todo en ' + g.t);
        if (vt2) q.appendChild(vt2);
        q.appendChild(lista(g.h, enlace));
        n3.appendChild(q);
      });
    });

    (d.nav || []).forEach(function (b) {
      var p = panel('NatMm-nav-' + b.i, b.t);
      var vt = verTodo(b.u, 'Ver todas');
      if (vt) p.appendChild(vt);
      p.appendChild(lista(b.g || [], enlace));
      n2.appendChild(p);
    });

    cont.appendChild(n2);
    cont.appendChild(n3);
  }

  // Lo que queda del viewport debajo del header (el _calculateMaxHeight de Warehouse).
  function medir() {
    if (!abierto) return;
    var alto = window.innerHeight - header.getBoundingClientRect().bottom;
    menu.style.setProperty('--nat-mm-alto', Math.max(alto, 200) + 'px');
  }

  function cerrarPaneles() {
    menu.querySelectorAll('.nat-mm__panel.is-nested.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    menu.querySelectorAll('[data-nat-mm-abre][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    menu.querySelectorAll('.nat-mm__panel[inert]').forEach(function (p) { p.removeAttribute('inert'); });
  }

  function ponerMenu(valor, devolverFoco) {
    if (valor === abierto) return;
    abierto = valor;
    if (abierto) construir();
    toggle.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    toggle.setAttribute('aria-label', abierto ? 'Cerrar menú' : 'Abrir menú');
    menu.setAttribute('aria-hidden', abierto ? 'false' : 'true');
    if (abierto) {
      medir();
      document.documentElement.setAttribute('scroll-lock', '');
    } else {
      cerrarPaneles();
      // El drawer del carrito usa el mismo atributo: no se suelta si sigue abierto.
      if (!document.querySelector('dialog[open]')) document.documentElement.removeAttribute('scroll-lock');
      if (devolverFoco) toggle.focus();
    }
  }

  toggle.addEventListener('click', function () { ponerMenu(!abierto, false); });

  menu.addEventListener('click', function (e) {
    var abre = e.target.closest('[data-nat-mm-abre]');
    if (abre) {
      var destino = document.getElementById(abre.getAttribute('aria-controls'));
      if (!destino) return;
      abre.setAttribute('aria-expanded', 'true');
      destino.classList.add('is-open');
      // El nivel tapado sale del orden de tabulación.
      var debajo = abre.closest('.nat-mm__panel');
      if (debajo) debajo.setAttribute('inert', '');
      var back = destino.querySelector('[data-nat-mm-cerrar]');
      if (back) back.focus({ preventScroll: true });
      return;
    }
    var cerrar = e.target.closest('[data-nat-mm-cerrar]');
    if (cerrar) cerrarPanel(cerrar.closest('.nat-mm__panel.is-open'));
  });

  function cerrarPanel(p) {
    if (!p) return;
    p.classList.remove('is-open');
    var opener = menu.querySelector('[aria-controls="' + p.id + '"]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      var debajo = opener.closest('.nat-mm__panel');
      if (debajo) debajo.removeAttribute('inert');
      opener.focus({ preventScroll: true });
    }
  }

  // Esc cierra el nivel de arriba; en el primero, cierra el cajón.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !abierto) return;
    var abiertos = menu.querySelectorAll('.nat-mm__panel.is-nested.is-open');
    if (abiertos.length) cerrarPanel(abiertos[abiertos.length - 1]);
    else ponerMenu(false, true);
  });

  document.addEventListener('click', function (e) {
    if (abierto && !header.contains(e.target)) ponerMenu(false, false);
  });

  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 1000px)').matches) ponerMenu(false, false);
    else medir();
  });

  // Abrir el carrito desde el cajón (o con el cajón abierto) lo cierra primero.
  root.addEventListener('click', function (e) {
    if (abierto && e.target.closest('[data-nat-cart-open]')) ponerMenu(false, false);
  }, true);

})();
